import { IconButton, Stack, Typography } from '@mui/material';
import { Edit } from '@mui/icons-material';
import React, { useState } from 'react';
import { StyledGlobalSwitch } from '../../ConfigurePage.styles';
import EditPhoneNumberNotificationModal, {
    EditPhoneNumberNotificationModalProps
} from './EditPhoneNumberNotificationModal';
import {
    useNotificationsDispatch,
    useNotificationsState
} from '../../../lib/contexts/NotificationsContext';
import { post } from '../../../lib/api';
import { NotificationActionTypes } from '../../../lib/contexts/NotificationsContext/actions';
import { formatPhoneNumber } from '../../../lib/helper/format-phone-number';
import { generatePostData } from '../../../lib/helper/generate-notifications-post-data';
import { toast } from 'react-toastify';

const TextNotification = () => {
    const context = useNotificationsState();
    const dispatch = useNotificationsDispatch();
    const [notificationsToggleDisabled, setNotificationsToggleDisabled] = useState(false);

    const [dialogOpen, setDialogOpen] = React.useState(false);
    const editIconClickHandler = () => {
        setDialogOpen(true);
    };

    const onEditSubmit: EditPhoneNumberNotificationModalProps['onSubmit'] = async (value) => {
        const result = await post(
            'notifications/edit/phone-number',
            generatePostData.phoneNumber(value)
        );

        if (result.status === 200) {
            dispatch({
                type: NotificationActionTypes.UpdateData,
                payload: result.data
            });
        }
    };

    const onSwitchToggle:
        | ((event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void)
        | undefined = async (event, checkbox) => {
        setNotificationsToggleDisabled(true);
        const toastId = toast.loading('Updating...');

        const result = await post(
            'notifications/edit/should-sms',
            generatePostData.shouldReceiveSms(checkbox)
        );

        if (result.status === 200) {
            dispatch({
                type: NotificationActionTypes.UpdateData,
                payload: result.data
            });

            toast.update(toastId, {
                render: 'Successfully updated!',
                type: 'success',
                autoClose: 5000,
                isLoading: false
            });
            toast.dismiss(toastId);
            setNotificationsToggleDisabled(false);
        } else {
            toast.update(toastId, {
                render: result.data.message,
                type: 'error',
                autoClose: 5000,
                isLoading: false
            });
            toast.dismiss(toastId);
            setNotificationsToggleDisabled(false);
        }
    };

    return (
        <>
            <Stack gap={2} height={'100%'} justifyContent="space-between">
                <Stack direction={'row'} justifyContent={'space-between'}>
                    <Typography fontSize={14} fontWeight={(t) => t.typography.fontWeightMedium}>
                        Text Notifications
                    </Typography>
                    <StyledGlobalSwitch
                        onChange={onSwitchToggle}
                        checked={context.shouldReceiveSms}
                        disabled={notificationsToggleDisabled}
                    />
                </Stack>
                <Stack direction={'row'} justifyContent={'space-between'} alignItems={'baseline'}>
                    <Stack direction={'row'} alignItems={'baseline'} gap={1}>
                        <Typography fontSize={16} fontWeight={(t) => t.typography.fontWeightBold}>
                            Phone:
                        </Typography>
                        <Typography fontSize={14} fontWeight={(t) => t.typography.fontWeightMedium}>
                            {formatPhoneNumber(context.phoneNumber)}
                        </Typography>
                    </Stack>
                    <IconButton onClick={editIconClickHandler} aria-label="edit">
                        <Edit fontSize={'small'} color={'primary'} />
                    </IconButton>
                </Stack>
            </Stack>
            <EditPhoneNumberNotificationModal
                value={context.phoneNumber}
                open={dialogOpen}
                onClose={() => {
                    setDialogOpen(false);
                }}
                onSubmit={onEditSubmit}
            />
        </>
    );
};

export default TextNotification;
